import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Picker, SystemText } from 'e4shared';
import { load, add, update, remove } from 'actions/admin';
import { setShowSuccess } from 'actions/ui';
import SimpleAdmin, { DefaultOptions } from 'components/simpleAdmin';
import BlobImage from 'components/blobImage';

export const AdminLocations = ({ history, ...props }) => {
    const dispatch = useDispatch();

    const [pickerItem, setPickerItem] = useState();
    const [showPicker, setShowPicker] = useState();

    const admin = useSelector(state => state.user.user?.sys_Config);
    const data = useSelector(state => state.admin.locations);
    const activeUsers = useSelector(state => state.admin.profiles?.filter(p => p.active));

    const onLoad = () => {
        dispatch(load('location'));
    };

    const loadActiveUsers = () => {
        dispatch(load('profile'));
    };

    const onAdd = (entity, callback) => {
        dispatch(add('location', entity, null, callback));
    };

    const onUpdate = (entity, callback) => {
        dispatch(update('location', entity, null, callback));
    };

    const onRemove = (ids, callback) => {
        if (!Array.isArray(ids)) ids = [ids];
        ids.forEach((id, idx) => {
            dispatch(remove('location', id, () => idx + 1 === ids.length && callback()));
        });
    };

    useEffect(() => {
        onLoad();
        loadActiveUsers();
    }, []);

    if (!admin) history.replace('/');

    const options = {
        ...DefaultOptions(),
        label: SystemText('Admin/Locations/Label/Options'),
    };

    const fields = [
        {
            label: SystemText('Admin/Locations/Fields/Label/Name'),
            type: 'text',
            mandatory: true,
            dataProperty: 'name',
            maxLength: 50,
            generalErrors: true,
            uniqueErrors: true,
            uniqueErrors_Text: SystemText('Admin/Locations/Fields/Error/Name'),
            help: SystemText('Admin/Locations/Fields/Help/Name'),
        },
        {
            label: SystemText('Admin/Locations/Fields/Label/Parent'),
            help: SystemText('Admin/Locations/Fields/Help/Parent'),
            type: 'select',
            dataProperty: 'parent_Id',
            isTree: true,
            data: [...data],
            dataBlock: 'id',
            allowMultiple: false,
            placeholder: SystemText('Admin/Locations/Fields/Placeholder/Parent'),
        },
        {
            label: SystemText('Admin/Locations/Fields/Label/Benchmarks'),
            type: 'toggle',
            mandatory: false,
            dataProperty: 'show_Benchmarks',
            help: SystemText('Admin/Locations/Fields/Help/Benchmarks'),
            inTitleBar: true,
        },
    ];

    const tableColumns = [
        { label: SystemText('Admin/Locations/Table/Columns/Label/Name'), dataProperty: 'name' },
        { label: SystemText('Admin/Locations/Table/Columns/Label/Parent'), dataProperty: 'parent' },
        {
            label: SystemText('Admin/Locations/Table/Columns/Label/Users'),
            dataProperty: 'staff_Ids',
            showCount: true,
            onClick: item => {
                setPickerItem(item);
                setShowPicker(true);
            },
        },
    ];

    return (
        <div data-testid="admin-locations-wrapper-testid">
            <SimpleAdmin
                {...props}
                data={data}
                add={onAdd}
                load={onLoad}
                update={onUpdate}
                remove={onRemove}
                fields={fields}
                options={options}
                columns={tableColumns}
                defaultValues={{ show_Benchmarks: true }}
            />
            <Picker
                title={SystemText('Admin/Locations/Pickers/Title/Users', pickerItem?.name)}
                help={SystemText('Admin/Locations/Pickers/Help/Users')}
                entity={SystemText('Admin/Locations/Pickers/Entity/Users')}
                data={activeUsers}
                nameProperty="full_Name"
                filterOption="staff"
                value={pickerItem?.staff_Ids}
                show={showPicker}
                onSave={ids => {
                    onUpdate({ ...pickerItem, update_Staff_Ids: ids }, () => {
                        dispatch(setShowSuccess(SystemText('Admin/Locations/ShowSuccess/SaveUsers')));
                        setShowPicker(false);
                        onLoad();
                    });
                }}
                onClose={() => {
                    setPickerItem(null);
                    setShowPicker(false);
                }}
                itemPrefix={p => (
                    <div className="image-holder mr10">
                        <BlobImage folder="avatar" src={p.avatar} />
                    </div>
                )}
            />
        </div>
    );
};

export default AdminLocations;
